import {newModalStore} from "@/store/helpers/modal-helper";
import {MmfVuexStoreHelper} from "./helpers/MmfVuexStoreHelper";

var storeHelper = new MmfVuexStoreHelper(newModalStore())
    .namespaced()
    .withStates({
        entity: null,
        entityObject: null
    })
    .withMutations({
        setupEntityModal(state, data) {
            state.entity = data.entity
            state.entityObject = data.entityObject
        }
    })

export default storeHelper.buildStore()
